import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { useT } from "../i18n";

// App shell: fixed sidebar on desktop, off-canvas drawer + hamburger topbar on mobile.
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const t = useT();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Content column — full width on mobile, offset by the sidebar on lg+ */}
      <div className="flex-1 lg:ml-72 min-h-0 h-screen overflow-y-auto">
        {/* Mobile top bar with hamburger — hidden on lg+ */}
        <div className="lg:hidden sticky top-0 z-20 flex items-center gap-3 h-14 px-4 bg-[#111827] text-white">
          <button
            type="button"
            aria-label={t("common.openMenu")}
            onClick={() => setSidebarOpen(true)}
            className="flex h-9 w-9 items-center justify-center rounded-lg hover:bg-white/10"
          >
            <i className="fa-solid fa-bars text-lg"></i>
          </button>
          <div className="flex items-center gap-2">
            <img src="/luxia.svg" alt={t("layout.logoAlt")} className="h-6 w-6 object-contain" />
            <span className="font-semibold">{t("layout.portalName")}</span>
          </div>
        </div>

        {children}
      </div>
    </div>
  );
};

export default Layout;
